import css from 'styled-jsx/css';

export default css.global`.footer h3 {
  margin-top: 0;
}

.footer-brand .social {
  margin-top: 3rem;
  margin-bottom: 2rem;
  pointer-events: none;
}

.footer-brand img {
  width: 250px;
}

.footer-brand p {
  color: #4d4d4d;
  font-weight: 500;
  margin-top: 0.5rem;
}

.footer-brand .social a {
  margin-right: 1.2rem;
  pointer-events: none;
}

.footer-brand .social a i {
  font-size: 2rem;
  color: #194D33;
}

#footer .footer-cont h3 {
  font-size: 1.8rem;
}

#footer a {
  font-size: 1.5rem;
  line-height: 2;
}
`